import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import NotFound from 'components/NotFound'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { keepAlive: false, title: 'mui-event-dev' },
    component: Home,
  },
  {
    path: '/launchAppDemo',
    name: 'LaunchAppDemo',
    meta: { keepAlive: false, title: 'LaunchApp' },
    component: () => import('@/components/LaunchAppDemo.vue'),
  },
  {
    path: '/signatureDemo',
    name: 'Signature',
    meta: { keepAlive: false, title: 'Signature' },
    component: () => import('@/components/SignatureDemo.vue'),
  },
  {
    path: '/imageResizerDemo',
    name: 'ImageResizerDemo',
    meta: { keepAlive: false, title: 'ImageResizer' },
    component: () => import('@/components/ImageResizerDemo.vue'),
  },
  {
    path: '/captchaDemo',
    name: 'CaptchaDemo',
    meta: { keepAlive: false, title: 'Captcha' },
    component: () => import('@/components/CaptchaDemo.vue'),
  },
  {
    path: '/addressPickerDemo',
    name: 'AddressPickerDemo',
    meta: { keepAlive: false, title: 'AddressPicker' },
    component: () => import('@/components/AddressPickerDemo.vue'),
  },
  {
    path: '/tableDemo',
    name: 'Table',
    meta: { keepAlive: false, title: 'Table' },
    component: () => import('@/components/TableDemo.vue'),
  },
  {
    path: '/addressInputDemo',
    name: 'AddressInput',
    meta: { keepAlive: false, title: 'AddressInput' },
    component: () => import('@/components/AddressInputDemo.vue'),
  },
  {
    path: '/addressEditDemo',
    name: 'AddressEdit',
    meta: { keepAlive: false, title: 'AddressEdit' },
    component: () => import('@/components/AddressEditDemo.vue'),
  },
  {
    path: '*',
    name: 'not found',
    component: NotFound,
  },
]

const router = new VueRouter({
  routes,
})

export default router
